export default {
  props: {
    listData: {
      default: () => []
    }
  },
  data () {
    return {
      paginator: {
        actualPage: 0,
        totalPage: null,
        perPage: 15,
        totalRegister: null
      }
    }
  },
  computed: {
    listDataPaginated () {
      this.paginator.totalRegister = this.listData.length
      this.paginator.totalPage = Math.floor(this.listData.length / this.paginator.perPage)
      const actualPagePerPage = this.paginator.actualPage * this.paginator.perPage
      const totalPagePerPage = actualPagePerPage + (this.paginator.actualPage + this.paginator.perPage)
      const listPaginated = this.listData.slice(actualPagePerPage, totalPagePerPage)
      return listPaginated
    }
  },
  // watch: {
  //   listData () {
  //     this.paginator.actualPage = 0
  //   }
  // },
  methods: {
    goToNextPage () {
      const nextPage = this.paginator.actualPage + 1
      if (nextPage >= this.paginator.totalPage) return
      this.paginator.actualPage++
    },
    goToPreviousPage () {
      const previousPage = this.paginator.actualPage - 1
      if (previousPage < 0) return
      this.paginator.actualPage--
    },
    goToPage (pPage) {
      if (pPage < 0 || pPage > this.paginator.totalPage) return
      this.paginator.actualPage = pPage
    }
    // buildQuery ({ filters } = {}) {
    //   const skip = this.paginator.actualPage * this.paginator.perPage
    //   const limit = this.paginator.perPage

    //   const query = {
    //     skip,
    //     limit
    //   }
    //   if (filters) query.filters = filters
    //   return query
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/primitives/paginator/mixin/Mixin.js